import { userConstants } from "../../constant";

const initialState = {
  certifications: [],
  loading: false,
};

export function productCertifications(state = initialState, action) {
  switch (action.type) {
    case userConstants.GET_PRODUCT_CERTIFICATIONS:
      return {
        ...state,
        certifications: action.payload || [],
        loading: false,
      };
    case userConstants.UPLOAD_PRODUCT_CERTIFICATION:
      return {
        ...state,
        certifications: [action.payload, ...state.certifications],
        loading: false,
      };
    default:
      return state;
  }
}
